// extracted by mini-css-extract-plugin
export var brand = "_1k-9";
export var button = "_1k-0";
export var chevron = "_1k-v";
export var chevronButton = "_1k-w";
export var content = "_1k-n";
export var danger = "_1k-g";
export var dangerOutlined = "_1k-h";
export var dark = "_1k-l";
export var darkTheme = "_1k-c";
export var extraSmall = "_1k-4";
export var fullWidth = "_1k-8";
export var ghost = "_1k-d";
export var gray = "_1k-t";
export var icon = "_1k-p";
export var iconButton = "_1k-s";
export var iconButtonBorder = "_1k-x";
export var iconButtonBorderDark = "_1k-y";
export var iconButtonBorderLight = "_1k-z";
export var iconLeft = "_1k-q";
export var iconRight = "_1k-r";
export var large = "_1k-1";
export var light = "_1k-m";
export var medium = "_1k-2";
export var micro = "_1k-5";
export var nano = "_1k-7";
export var outlined = "_1k-k";
export var pending = "_1k-a";
export var primary = "_1k-i";
export var shadow = "_1k-o";
export var small = "_1k-3";
export var solidLight = "_1k-e";
export var solidLightBrand = "_1k-f";
export var spinner = "_1k-u";
export var transparent = "_1k-j";
export var warning = "_1k-b";
export var wideNano = "_1k-6";